module.exports = __webpack_public_path__ + "images/emoji/beer.ce36c3ef882914e9dc74.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/beer.png
// module id = JLyx
// module chunks = 13